module.exports = __webpack_public_path__ + "img/partner-6.08b015da.png";